import { getActualHeight, getActualWidth, parseValue } from "@client/lib/values/size";
import { Dimension } from "@client/types";
import * as React from "react";

export const getImageStyle = (
  sizeStr: string,
  style: React.CSSProperties | undefined,
  isFixedSize?: boolean
): React.CSSProperties => {
  const size = parseValue(sizeStr);

  if (size.useAspectRatio) {
    // NOTE: height 100% distorts images in Safari
    return {
      aspectRatio: "auto",
      width: size.dimension === Dimension.Width ? "100%" : undefined,
      maxHeight: size.dimension === Dimension.Height ? size.dimensionSize : undefined,
      maxWidth: size.dimension === Dimension.Width ? size.dimensionSize : undefined,
      objectFit: "contain",
      objectPosition: "top",
      ...(style || {})
    };
  }

  if (isFixedSize) {
    const height = getActualHeight(size)!;
    const width = getActualWidth(size)!;

    return {
      height,
      maxHeight: "100%",
      minWidth: width,
      objectFit: "cover",
      width,
      maxWidth: "100%",
      ...(style || {})
    };
  }

  return {
    aspectRatio: size.height ? size.width / size.height : undefined,
    width: size.width,
    maxHeight: "100%",
    maxWidth: "100%",
    objectFit: "cover",
    ...(style || {})
  };
};
